import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
    transform(value: any, args: any): any {

        if (typeof value === "string") {
            if (!args || !value) {
                return value;
            }
            //TODO BW: https://stackoverflow.com/questions/57815244/highlight-multiple-strings-in-a-statement-javascript
            const regex = new RegExp(args, 'gi');
            const match = regex ? value.match(regex) : [];
            if (!match || match.length == 0) {
                return value;
            }

            return value.replace(regex, `<span class='highlightText'>${match[0]}</span>`);
        } else {
            return value;
        }
    }
}
